/* @flow */

import React from 'react';
import getConfig from 'next/config';
import Router from 'next/router';
import styled from 'styled-components';
// $FlowFixMe
import QRCode from 'qrcode.react';

import {
  Button, Tooltip, Modal, Message,
  // $FlowFixMe
} from '@bijie/react-bnb';

import { getLabel } from '../../../../utils/i18n';
import { getUrlParam } from '../../../../utils/urlUtils';
import API_PATH from '../../../../actions/actionsFactory/apiPath';
import { gwPost } from '../../../../actions/actionsFactory/gwRequest';
import { setPostBody } from '../../../../actions/actionsFactory';
import FlexBox from '../../../FlexBox';
import Icon from '../../../Icon';
import { Link } from '../../../../routes';
import { TOAST_FADE_TIME } from '../../../../config/constantNg';

const {
  publicRuntimeConfig: {
    assetPrefix,
  },
} = getConfig();

const { FACE_INIT_API_PATH, WEB_FACE_INIT_API_PATH, UPDATA_FACE_VERIFY_STATUS } = API_PATH;

const Wrap = styled(FlexBox)`
  font-family:${({ theme }) => theme.fontIBMRegular};
  width: 100%;
  > h4 {
    width: 100%;
    text-align: center;
    font-size:16px;
    color:rgba(33,40,51,1);
    line-height:20px;
    margin: 0 0 58px;
    span {
      color: ${({ theme }) => theme.highlight};
    }
  }
`;
const Main = styled(FlexBox)`
  width: 100%;
  max-width: 525px;
  > ul {
    margin-left: 36px;
    line-height: 100%;
    font-size:14px;
    color:rgba(37,45,56,1);
    line-height:22px;
    li {
      margin-bottom: 12px;
      span {
        color: ${({ theme }) => theme.highlight};
      }
      i {
        font-style: normal;
      }
    }
    a, a:visited {
      color: ${({ theme }) => theme.highlight};
    }
    a:hover {
      text-decoration: underline;
    }
    .icon-prompt {
      margin-left: 6px;
      cursor: pointer;
      vertical-align: middle;
    }
  }
`;

const Footer = styled(FlexBox)`
  width: 100%;
  > span {
    font-size:14px;
    color:rgba(132,142,156,1);
    line-height:18px;
    cursor: pointer;
  }
`;
const ModalContent = styled.div`
  font-family: ${({ theme }) => theme.fontIBMRegular};
`;

type Props = {
  i18n: Object,
  mode: string,
  transId: string,
  locale: string,
};

type State = {
  QRCodeValue: string,
  isRequesting: boolean,
}

export default
class FacialInfo extends React.Component<Props, State> {
  static defaultProps = {
    i18n: {},
    mode: 'kyc',
    locale: 'en',
  }

  state = {
    QRCodeValue: '',
    isRequesting: false,
  }

  async componentDidMount() {
    const { i18n, locale, mode } = this.props;
    const result = await this._getFaceInfo(FACE_INIT_API_PATH);
    if (!result) return;
    let modalIconSrc = '';
    let modalContent = '';
    let okText = '';
    let okFun = () => {};
    if (result.success) {
      modalIconSrc = assetPrefix + require('../images/faceVerify.svg');
      modalContent = getLabel('exchange-kyc-faceVerifyTip', i18n);
      okText = getLabel('exchange-kyc-iAmOwner', i18n);
      okFun = () => {
        // $FlowFixMe
        localStorage.setItem('faceKYCConfirm', true);
      };
      this.setState({
        QRCodeValue: result.data.qrCode,
      });
    } else {
      modalIconSrc = assetPrefix + require('../images/verificationFailed.svg');
      modalContent = result.message;
      okText = getLabel('exchange-kyc-returnToProfile', i18n);
      okFun = () => {
        let url = `/${locale}/usercenter/settings/profile`;
        mode === 'reset2fa' && (url = `/${locale}`);
        Router.push(url);
      };
    }
    const faceKYCConfirm = localStorage.getItem('faceKYCConfirm');
    if (result.success && faceKYCConfirm) return;
    Modal.info({
      icon: <img src={modalIconSrc} alt="icon" />,
      content: <ModalContent>{modalContent}</ModalContent>,
      okText,
      onOk() {
        okFun();
      },
    });
  }

  _getFaceInfo = async (apiPath: string) => {
    const transId = getUrlParam('id') || this.props.transId;
    const type = getUrlParam('type');
    if (!transId || !type) return false;
    const params = setPostBody({
      transId,
      type,
    });
    const result = await gwPost(apiPath, params);
    return result;
  }

  _confirm = async () => {
    const { i18n, locale, mode } = this.props;
    const { isRequesting } = this.state;
    if (isRequesting) return;
    this.setState({ isRequesting: true });
    const result = await this._getFaceInfo(WEB_FACE_INIT_API_PATH);
    if (!result) return;
    const iconStyle = { width: '105px', height: '105px' };
    if (result.success) {
      Modal.confirm({
        content: <ModalContent>{getLabel('exchange-kyc-faceVerifyRecommend', i18n)}</ModalContent>,
        icon: <img src={assetPrefix + require('../../sure-cancel.svg')} style={iconStyle} alt="icon" />,
        onOk() {
          window.location.href = result.data.livenessUrl;
        },
        okText: getLabel('exchange-common-confirm', i18n),
        onCancel() {
          // noop
        },
        cancelText: getLabel('exchange-common-cancel', i18n),
      });
    } else {
      Modal.info({
        icon: <img src={assetPrefix + require('../images/verificationFailed.svg')} alt="icon" />,
        content: <ModalContent>{result.message}</ModalContent>,
        okText: getLabel('exchange-kyc-returnToProfile', i18n),
        closable: true,
        onOk() {
          let url = `/${locale}/usercenter/settings/profile`;
          mode === 'reset2fa' && (url = `/${locale}`);
          Router.push(url);
        },
      });
    }
    this.setState({ isRequesting: false });
  }

  _updateFaceVerifyStatus = async () => {
    const type = getUrlParam('type');
    const { locale, i18n, mode } = this.props;
    const result = await this._getFaceInfo(UPDATA_FACE_VERIFY_STATUS);
    if (!result) return;
    if (result.success) {
      if (result.data) {
        let url = `/${locale}/usercenter/settings/profile`;
        mode === 'reset2fa' && (url = `/${locale}/reset2fa-langding/facial?status=1&type=${type}`);
        Router.push(url);
      } else if (mode === 'reset2fa') {
        Router.push(`/${locale}/reset2fa-langding/facial?status=0&type=${type}`);
      } else {
        Message.fail(getLabel('exchange-kyc-notCompleteFacial', i18n), TOAST_FADE_TIME);
      }
    } else {
      Message.fail(result.message, TOAST_FADE_TIME);
    }
  }

  render() {
    const { i18n, locale, mode } = this.props;
    return (
      <Wrap justify="center">
        {/* eslint-disable-next-line */}
        {mode === 'reset2fa' && <h1 className='sub-title'>{getLabel('exchange-reset2fa-facialVerify', i18n)}</h1>}
        {/* eslint-disable-next-line */}
        <h4 dangerouslySetInnerHTML={{ __html: getLabel('exchange-kyc-scanQRCodeTip', i18n) }} />
        <Main wrap="nowrap">
          {this.state.QRCodeValue && <QRCode value={this.state.QRCodeValue} size={100} />}
          <ul>
            <li>
              {getLabel('exchange-kyc-noBinanceAPP', i18n)}
              <Link route={`/${locale}/download`}><a>{getLabel('exchange-download-title', i18n)} {'>>'}</a></Link>
            </li>
            <li>
              {/* eslint-disable-next-line */}
              <i dangerouslySetInnerHTML={{ __html: getLabel('exchange-kyc-scanInAppTip', i18n) }} />
              <Tooltip
                placement="top"
                trigger={['hover']}
                overlay={<img src={assetPrefix + require('../images/toMobileVerifyTips.png')} alt="icon" />}
              >
                <Icon type="prompt" size={16} color="#48515D" />
              </Tooltip>
            </li>
          </ul>
        </Main>
        <Footer justify="space-between" align="center" margin="60px 0 0">
          <span onClick={this._confirm}>{getLabel('exchange-kyc-facialInfoPCAUTH', i18n)}</span>
          <Button type="primary" size="lg" onClick={this._updateFaceVerifyStatus}>{getLabel('exchange-kyc-completedOnPhone', i18n)}</Button>
        </Footer>
      </Wrap>
    );
  }
}
